import { useState } from 'react'

import Navbar from './Navbar'
import Sidebar from './Sidebar'
import TopNavbar from './TopNavbar'

type TLayout = {
  mainContent: React.ReactNode
  navbarContent?: React.ReactNode
  isSidebar?: boolean
}

const Layout = ({ navbarContent, mainContent, isSidebar = true }: TLayout) => {
  const [sidebarActive, setSideBarActive] = useState<boolean>(false)

  const toggleSidebarActive = () => {
    setSideBarActive(!sidebarActive)
  }

  return (
    <>
      <TopNavbar toggleSidebarActive={toggleSidebarActive} />
      <Navbar>{navbarContent}</Navbar>
      {isSidebar && <Sidebar isOpen={sidebarActive} toggleSidebarActive={toggleSidebarActive} />}
      <main className="layout">{mainContent}</main>
    </>
  )
}

export default Layout
